import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../common/breadcrumbs";
import { URL } from "../../../constants/URL";
import { useParams } from "react-router";
import swal from "sweetalert2";
import PromotionForm from "./PromotionForm";
import { useGetPromotionById, useSendPromotion } from "../../../queryHooks";
import CS from "../../../services/commonService";
import ApiLoader from "../../../loaders/ApiLoader";

const SendPromotion = () => {
	const { slug } = useParams();
	const [edit, setEdit] = useState(false);
	const [promoData, setPromoData] = useState();

	const { data: promoApiData } = useGetPromotionById(slug);

	useEffect(() => {
		if (promoApiData?.status === "success") {
			setPromoData(promoApiData?.data);
		}
	}, [promoApiData]);

	const {
		mutateAsync: sendPromotionAsync,
		data: sendPromoData,
		error: sendPromoError,
		isLoading: sendPromoLoading,
	} = useSendPromotion();

	useEffect(() => {
		if (sendPromoData) {
			CS.showSuccessMessage(
				`${sendPromoData?.data?.message || sendPromoData?.message}`
			);
		}
	}, [sendPromoData]);

	useEffect(() => {
		if (sendPromoError) {
			CS.showErrorMessage(
				`${
					sendPromoError?.response?.data?.message ||
					sendPromoError?.data?.message ||
					sendPromoError?.message
				}`
			);
		}
	}, [sendPromoError]);

	const sendPromotionHandler = () => {
		if (edit) {
			swal.fire({
				icon: "warning",
				text: "Please save this promotion before sending",
			});
			return;
		}
		swal
			.fire({
				// title: "Are you sure, you want to send notification to all users?",
				// text: `You won't be able to revert this!`,
				text: "Are you sure, you want to send notification to all users?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes",
			})
			.then((result) => {
				if (result.isConfirmed) {
					sendPromotionAsync(slug);
				}
			});
	};

	return (
		<>
			{sendPromoLoading && <ApiLoader />}
			<Breadcrumbs
				title="Promotions"
				data={[
					{ label: "Promotions", path: URL.promotions },
					{ label: "Promotions Details" },
				]}
			/>
			<div className="user-listing-filterOptions mb-2 mt-3 d-block">
				<div className="row mb-2">
					<div className="col-sm-8 mb-2 position-static"></div>
					<div className="col-sm-4">
						<div className="right-buttons d-flex justify-content-end">
							{!edit && (
								<button
									className="btn btn-default minW-md-0 btn-bg-white"
									onClick={() => {
										setEdit(!edit);
									}}
								>
									Edit
								</button>
							)}
							<button
								className="btn btn-primary glow-primary mr-4"
								onClick={sendPromotionHandler}
							>
								Send
							</button>
						</div>
					</div>
				</div>
			</div>
			<PromotionForm
				slug={slug}
				edit={edit}
				editChange={() => {
					setEdit(!edit);
				}}
				promotionData={promoData}
			/>
		</>
	);
};

export default SendPromotion;
